<template>
  <span class="most-popular">
    <a-icon icon="fa:solid:certificate" />
    <span>Most pop</span>
  </span>
</template>

<script>
export default {
  name: "MostPopBadge",
};
</script>

<style lang="scss" scoped>
$badge-size: 70px;
.most-popular {
  svg {
    position: absolute;
    top: 0;
    left: 0;
    color: #3772ff;
    font-size: $badge-size;
    filter: drop-shadow( 0 1px 3px rgba( 0, 0, 0, 0.3 ) );
  }

  span {
    height: $badge-size;
    width: $badge-size;
    text-align: center;
    display: flex;
    align-items: center;
    justify-content: center;
    padding: 15px 10px 10px;
    line-height: 1.25;
    position: relative;
    text-shadow: none;
    font-size: 0.9rem;
    font-weight: 600;
    letter-spacing: -0.1em;
    color: #fff;
    text-transform: uppercase;
    transform: rotate( 20deg );
  }
}
</style>
